<template>
  <span
    v-if="value && relative"
    v-tooltip="{
      content: tooltip ? dateValue : null,
      delay: { show: 500, hide: 0 },
    }"
  >
    {{ relativeValue }}
  </span>
  <span v-else-if="value">{{ dateValue }}</span>
</template>

<script>
import { format, formatDistanceStrict } from "date-fns";

export default {
  props: {
    value: [Number, Boolean, String],
    relative: {
      type: Boolean,
      default: true,
    },
    tooltip: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    relativeValue() {
      return formatDistanceStrict(this.value * 1000, new Date(), {
        addSuffix: true,
      });
    },
    dateValue() {
      return format(this.value * 1000, "dd/MM/yyyy hh:mm:ss a");
    },
  },
};
</script>
